import React, { lazy } from 'react';
import { ROLES } from "./util/constants";
import { configStore } from './state/CommonState';
import TenantUtils from './util/tenant.utils';
import quickquotemobileicon from './assets/images/m-qickquote-icon.svg';
import Dashboardv3 from './mytasks/task-listv2';

const ListQuote = lazy(() => import('./ListQuote'));
const QuoteMain = lazy(() => import('./QuoteMain'));
const MainAguser = lazy(() => import('./agusers/main-agusers'));
const Tbd = lazy(() => import('./tbd.'));
const MainEntity = lazy(() => import('./entity/main-entity'));
const MainEntityV2 = lazy(() => import('./entity-v2/Entities/main-entity-v2'));
const MainVehicle = lazy(() => import('./vehicle/main-vehicle'));
const MainBranch = lazy(() => import('./entity-v2/Branches/main-branch'));
const MainDrivers = lazy(() => import('./drivers/main-drivers'));
const MainScrappers = lazy(() => import('./scrappers/main-scrappers'));
const EditAguser = lazy(() => import('./agusers/edit-aguser'));
const QuoteListClient = lazy(() => import('./schedules/QuoteListClient'));
const QuoteListBPO = lazy(() => import('./schedules/QuoteListBPO'));
const QuoteClientMain = lazy(() => import('./schedules/QuoteClientMain'));
const Dashboard = lazy(() => import('./components/dashboard'));
const StaffHome = lazy(() => import('./home/StaffHome'));
const CrmAnalytics = lazy(() => import('./home/CrmAnalytics'));
const BookingList = lazy(() => import('./mybooks/booking-list'));
const ListEnquiry = lazy(() => import('./enquiry/list-enquiry'));
const HomeScreen = lazy(() => import('./enquiry/home-screen'));
const HomeMain = lazy(() => import('./enquiry/home-main'));
const ListEnquiryMain = lazy(() => import('./enquiry/list-enquiry-main'));
const ListBookingsMain = lazy(() => import('./mybooks/booking-list-main'));
const MainMyactions = lazy(() => import('./my-actions/main-myactions'));
const CustomerMyactions = lazy(() => import('./my-actions/customer-myactions'));
const EnquiryHome = lazy(() => import('./enquiry/enquiry_home'));
const TaskList = lazy(() => import('./mytasks/task-list'));
const C1 = lazy(() => import('./charts/c1').then(m => ({ default: m.C1 })));
const ChartHome = lazy(() => import('./charts/chart.home').then(m => ({ default: m.ChartHome })));
const ChartNewHome = lazy(() => import('./charts/chart.new.home').then(m => ({ default: m.ChartNewHome })));
const Uploads = lazy(() => import('./uploads/uploads'));
const AIConsoleMain = lazy(() => import('./ai_console/AIConsoleMain'));
const PricingCalc = lazy(() => import('./pricing/pricing.calc'));
const AuditAgusers = lazy(() => import('./agusers/audit-agusers'));
const PricingScreen = lazy(() => import('./pricing/pricing.screen'));
const Report = lazy(() => import('./Report'));
const Home2 = lazy(() => import('./Home2'));
const DtQuoteMain = lazy(() => import('./dt/DtQuoteMain'));
const DtBookingMain = lazy(() => import('./dt/DtBookingMain'));
const DtContractMain = lazy(() => import('./dt/DtcontractMain'));
const Devices = lazy(() => import('./components/devices'));
const SiteInformation = lazy(() => import('./siteinformation/siteinformation'));
const PricingScreen2 = lazy(() => import('./pricing/pricing.screen.v2'));
const Dtactionslist = lazy(() => import('./dtactions/dtactions-list'));
const PricingConfig = lazy(() => import('./pricing/pricing-config'));
const QuoteMainv2 = lazy(() => import('./quotes/quote-main-v2'));
const Operationscb = lazy(() => import('./Operationscb'));
const CustomersUsers = lazy(() => import('./CustomersUsers'));
const Salescb = lazy(() => import('./Salescb'));
const HomeMainv2 = lazy(() => import('./enquiryv2/home-main-v2'));
const ListBookingsMainv2 = lazy(() => import('./mybooksv2/booking-list-main-v2'));
const Spotv3 = lazy(() => import('./spotv3/spot.v3'));
const SpotBookingv3 = lazy(() => import('./spotv3/spot.booking.v3'));
const MainEntityApproval = lazy(() => import('./entity-approvals/main-entityApproval'));
const Fclpricing = lazy(() => import('./fclpricing'));
const TrackMyBooking = lazy(() => import('./trackmybookings/TrackMyBookings'));
const EnquiryHomeV2 = lazy(() => import('./enquiryv2/enquiry_home-v2'));
const Schedules = lazy(() => import('./port-to-port-schedules/schedules'));
const ListEnquiryMainv3 = lazy(() => import('./enquiryv3/list-enquiry-main-v3'));
const QuoteMainv3 = lazy(() => import('./quotesv3/quote-main-v3'));
const HomeMainv3 = lazy(() => import('./enquiryv3/home-main-v3'));
const ListBookingsMainv3 = lazy(() => import('./mybooksv3/booking-list-main-v3'));
const QuickQuotev3 = lazy(() => import('./quick-quotev3/quick-quote-v3'));
const PowerbiPage = lazy(() => import('./powerbi/powerbiPage'));
const MainRoles = lazy(() => import('./roles/main-roles'));
const ChartRedesignHome = lazy(() => import('./charts/chartredesign.home').then(m => ({ default: m.ChartRedesignHome })));
const CartingOrderList = lazy(() => import('./cartingorder/cartingorder-list'));
const MasterJob = lazy(() => import('./masterJob/masterJob'));
const PlanningConsole = lazy(() => import('./planningConsole/planningConsole'));
const ChartVisibilityHome = lazy(() => import('./components/dashboard/chartvisibilityhome'));
const QuoteApprovalMain = lazy(() => import('./quote-approval/quote-approval-main'));
const QuickQuotev4 = lazy(() => import('./quick-quotev3/quick-quote-v4'));
const RateRequestMain = lazy(() => import('./rate-request/rate-request-main'));
const RequestApprovalMain = lazy(() => import('./raterequest-approval/request-approval-main'));
const CartingOrderMobileView = lazy(() => import('./cartingorder/cartingorder-mobile-view'))
const UploadDocumentsHub = lazy(() => import('./cartingorder/upload-documents-hub'))
const ManageCrmMobile = lazy(() => import('./entity-v2/CRM/manage-crm-mobile'));
const Leads = lazy(() => import('./entity-v2/Entities/leads'));

const excludedRolesForReportsAuditAccess = [
    ROLES.CENTRAL.BPO,
    "OPERATIONS",
    "CLIENT USER",
];

const oldExcludedRoles = [ROLES.CENTRAL.BPO, "OPERATIONS", "CLIENT USER"];

let menuList = [
    {
        name: 'Data Discrepancies',
        key: 'Data Discrepancies',
        href: '/',
        component: <StaffHome />,
        isRoleBased: true,
        classname: "data_discrepancies"
    },
    {
        name: 'CRM Analytics',
        key: 'CRM Analytics',
        href: '/',
        component: <CrmAnalytics />,
        isRoleBased: true,
        classname: "crm_analytics"
    },
    // {
    //     name: 'Home',
    //     key: 'Home',
    //     href: '/',
    //     component: <ChartNewHome />,
    //     // component : <ChartRedesignHome/>,
    //     isRoleBased: true,
    //     classname: "home"
    // },
    {
        name: 'Finance Dashboard' ,
        key: 'Finance Dashboard',
        href: '/',
        // component: <ChartNewHome />,
        component : <ChartRedesignHome/>,
        isRoleBased: true,
        classname: "finance_dashboard"
    },
     {
        name: 'Visibility Dashboard',
        key: 'Visibility Dashboard',
        href: '/',
        component : <ChartVisibilityHome/>,
        isRoleBased: true,
        classname: "visibility_dashboard"
    },
    {
        name: 'Cross-Border',
        key: '',
        classname: "crossborder",
        isRoleBased: true,
        children: [
            // {
            //     name: 'Enquiries Received',
            //     key: 'Enquiries',
            //     href: '/',
            //     component: <ListEnquiryMain />,
            //     isRoleBased: true,
            //     classname: "enquiries"
            // },
            {
                name: 'Enquiries Received',
                key: 'Enquiriesv3',
                href: '/',
                component: <ListEnquiryMainv3 />,
                isRoleBased: true,
                classname: "enquiries"
            },

            // {
            //     name: 'Quotations',
            //     key: 'Quotation',
            //     href: '/',
            //     component: <QuoteMain />,
            //     classname: "crossborderquotes"
            // },
            // {
            //     name: 'Quotations',
            //     key: 'Quotationv2',
            //     href: '/',
            //     component: <QuoteMainv2 />,
            //     isRoleBased: true,
            //     classname: "crossborderquotes"
            // },
            {
                name: 'Quotations',
                key: 'Quotationv3',
                href: '/',
                component: <QuoteMainv3 />,
                isRoleBased: true,
                classname: "crossborderquotes"
            },
            {
                name: 'Quotations Approval',
                key: 'Quotationvapproval',
                href: '/',
                component: <QuoteApprovalMain />,
                isRoleBased: true,
                classname: "crossborderquotes"
            },
            {
                name: 'Rate Request',
                key: 'RateRequest',
                href: '/',
                component: <RateRequestMain />,
                isRoleBased: true,
                classname: "crossborderquotes"
            },
            {
                name: 'Rate Request Approval',
                key: 'RateRequestapproval',
                href: '/',
                component: <RequestApprovalMain />,
                isRoleBased: true,
                classname: "crossborderquotes"
            },
            // {
            //     name: 'Upload Schedules',
            //     key: 'Upload Schedules',
            //     href: '/',
            //     component: <HomeMain />,
            //     classname: "uploadschedules",
            // },
            // {
            //     name: 'Upload Schedules',
            //     key: 'Upload Schedulesv2',
            //     href: '/',
            //     component: <HomeMainv2 />,
            //     isRoleBased: true,
            //     classname: "uploadschedulesv2",
            // },
            {
                name: 'Upload Schedules',
                key: 'Upload Schedulesv3',
                href: '/',
                component: <HomeMainv3 />,
                isRoleBased: true,
                classname: "uploadschedulesv3",
            },
            /*{
                name: 'Spot Booking - LCL',
                key: 'Spot Booking - LCL',
                href: '/',
                component: <PricingScreen2 />,
                isRoleBased: true,
                classname: "pricingcalculator",
            },*/
            // {
            //     name: 'Quick Quote',
            //     key: 'Spot Booking WIP',
            //     href: '/',
            //     component: <Spotv3 />,
            //     isRoleBased: true,
            //     classname: "spotv3",
            // },
            // {
            //     name: 'Quick Quote',
            //     key: 'Spot Booking WIP',
            //     href: '/',
            //     component: <QuickQuotev3 />,
            //     isRoleBased: true,
            //     classname: "spotv3",
            //     mobileIcon : quickquotemobileicon,
            //     isMobileView:true
            // },
            {
                name: 'Quick Quote',
                key: 'Spot Booking WIP', //Spot Booking Streams
                href: '/',
                component: <QuickQuotev4 />,
                isRoleBased: true,
                classname: "spotv4",
                mobileIcon : quickquotemobileicon,
                isMobileView:true
            },
            // {
            //     name: 'Bookings',
            //     key: 'Bookings',
            //     href: '/',
            //     component: <ListBookingsMain />,
            //     classname: "crossborder_bookings",
            // },
            // {
            //     name: 'Bookings',
            //     key: 'Bookingsv2',
            //     href: '/',
            //     component: <ListBookingsMainv2 />,
            //     isRoleBased: true,
            //     classname: "crossborder_bookingsv2",
            // },
            {
                name: 'Bookings',
                key: 'Bookingsv3',
                href: '/',
                component: <ListBookingsMainv3 />,
                isRoleBased: true,
                classname: "crossborder_bookingsv2",
            },
            {
                name: 'Visibility',
                key: 'Visibility',
                href: '/',
                component: <CustomerMyactions />,
                isRoleBased: true,
                classname: "visibility",
            },
            {
                name: 'My Actions',
                key: 'My Actions',
                href: '/',
                component: <TaskList />,
                isRoleBased: true,
                classname: "myactions",
            },
            {
                name: 'My ActionsV2',
                key: 'My ActionsV2',
                href: '/',
                component: <Dashboardv3 />,
                isRoleBased: true,
                classname: "myactions",
            },
            {
                name: 'Carting Sheet',
                key: 'Carting Sheet',
                href: '/',
                component: <CartingOrderList />,
                isRoleBased: true,
                classname: "cartingorder",
                mobileIcon : quickquotemobileicon,
                isMobileView:true,
                mobileComponent: <CartingOrderMobileView/>
            },
            {
                name: 'Manage CRM',
                key: 'Manage CRM',
                href: '/',
                component: <ManageCrmMobile />,
                isRoleBased: true,
                classname: "managecrm",
                mobileIcon : quickquotemobileicon,
                isMobileView: true,
                isMobileOnly: true,
                mobileComponent: <ManageCrmMobile />
            },
            {
                name: 'Carting Photos',
                key: 'Carting Photos',
                href: '/',
                component: <UploadDocumentsHub />,
                isRoleBased: true,
                classname: "cartingphotos",
                mobileIcon : quickquotemobileicon,
                isMobileView: true,
                isMobileOnly: true,
                mobileComponent: <UploadDocumentsHub />
            },
            {
                name: 'Console Planning',
                key: 'Console Planning',
                href: '/',
                component: <PlanningConsole />,
                isRoleBased: true,
                classname: "planningConsole",
            },
            {
                name: 'Master Job',
                key: 'Master Job',
                href: '/',
                component: <MasterJob/>,
                isRoleBased: true,
                classname: "masterjob",
            }
        ],
    },
    // {
    //     name: process.env.REACT_APP_ENTERPRISE_NAME_SMALLCASE === 'agraga'?'Domestic Transport':null,
    //     key: '',
    //     isRoleBased: true,
    //     classname: "domestictransport",
    //     children: [
    //         {
    //             name: 'Quotations',
    //             key: 'Domestic Quotations',
    //             href: '/',
    //             component: <DtQuoteMain />,
    //             isRoleBased: true,
    //             classname: "domesticquotes",
    //         },
    //         {
    //             name: 'Bookings',
    //             key: 'Domestic Transport Booking',
    //             href: '/',
    //             component: <DtBookingMain />,
    //             isRoleBased: true,
    //             classname: "domestictransport_bookings",
    //         },
    //         {
    //             name: 'My Actions',
    //             key: 'Domestic Transport Actions',
    //             href: '/',
    //             component: <Dtactionslist />,
    //             isRoleBased: true,
    //             classname: "dtactionslist",
    //         },
    //     ],
    // },
    // {
    //     name: 'Analytics',
    //     key: '',
    //     classname: "analytics",
    //     isRoleBased: true,
    //     children: [
    //         {
    //             name: 'Operations CB',
    //             key: 'Operations CB',
    //             href: '/',
    //             component: <Operationscb />,
    //             isRoleBased: true,
    //             classname: "operations_cb",
    //         },
    //         {
    //             name: 'Sales CB',
    //             key: 'Sales CB',
    //             href: '/',
    //             component: <Salescb />,
    //             classname: "sales_cb",
    //             isRoleBased: true,
    //         },
    //         {
    //             name: 'FCL Pricing',
    //             key: 'FCL Pricing',
    //             href: '/',
    //             component: <Fclpricing />,
    //             isRoleBased: true,
    //             classname: "fclpricing",
    //         },
    //     ],
    // },
    {
        name: 'Config',
        key: 'Config',
        href: '/',
        component: <PricingConfig />,
        classname: "config",
        isRoleBased: true,
    },
    {
        name: 'Schedules',
        key: 'Schedules',
        href: '/',
        component: <Schedules />,
        classname: "config",
        isRoleBased: true,
    },
    {
        name: 'PowerBI',
        key: 'PowerBI',
        href: '/',
        component: <PowerbiPage />,
        classname: "config",
        isRoleBased: true,
    },
    {
        name: 'Uploads',
        key: 'Uploads',
        href: '/',
        component: <Uploads />,
        classname: "uploads",
        isRoleBased: true,
    },
    {
        name: 'AI Overriding',
        key: 'AI Overriding',
        href: '/',
        component: <AIConsoleMain />,
        classname: "aiconsole",
        isRoleBased: true,
    },
    // {
    //     name: 'Entities',
    //     key: 'Entities',
    //     href: '/',
    //     component: <MainEntity />,
    //     isRoleBased: true,
    //     classname: "entities",
    // },
    {
        name: 'Entities',
        key: 'Entitiesv2',
        href: '/',
        isRoleBased: true,
        component: <MainEntityV2 />
    },
    //  {   
    //     name: 'Lead Management',
    //     key: 'Leads',
    //     href: '/',
    //     isRoleBased: true,
    //     component: < Leads />
    // },
    {
        name: 'Approvals',
        key: 'Approvals',
        href: '/',
        component: <MainEntityApproval />,
        isRoleBased: true,
    },
    {
        name: 'Vehicles',
        key: 'Vehicle List',
        href: '/',
        isRoleBased: true,
        component: < MainVehicle />
    },
    {   
        name: 'Drivers',
        key: 'Drivers List',
        href: '/',
        isRoleBased: true,
        component: < MainDrivers />
    },
    {   
        name: 'Scrappers',
        key: 'Scrappers',
        href: '/',
        isRoleBased: true,
        component: < MainScrappers />
    },
    {   
        name: 'Roles',
        key: 'Roles',
        href: '/',
        isRoleBased: true,
        component: < MainRoles />
    },
    {
        name: 'Customers',
        key: 'Customers',
        href: '/',
        component: <CustomersUsers />,
        isRoleBased: true,
        classname: "customers_users",
    },
    {
        name: 'Users',
        key: 'Users',
        href: '/',
        isRoleBased: true,
        component: <MainAguser />,
        classname: "users",
    },
    {
        name: 'Audit',
        key: 'Audit',
        href: '/',
        isRoleBased: true,
        component: <AuditAgusers />,
        classname: "audit",
    },
    {
        name: 'Reports',
        key: 'Reports',
        href: '/',
        component: <Report />,
        isRoleBased: true,
        // exclude: excludedRolesForReportsAuditAccess,
        classname: "reports",
    },
    {
        name: 'Access Control',
        key: 'Devices',
        href: '/',
        component: <Devices />,
        isRoleBased: true,
        // exclude: excludedRolesForReportsAuditAccess,
        classname: "devices",
    },
    // {
    //     name: 'Site-Information',
    //     key: 'Site-Information',
    //     href: '/',
    //     isRoleBased: true,
    //     component: <SiteInformation />,
    //     classname: "siteinformation",
    // }
]
if(process.env.REACT_APP_ENTERPRISE_NAME_SMALLCASE != 'agraga'){
    let m = []
    for (let i = 0; i < menuList.length; i++) {
        if(menuList[i].name!=undefined){
            if(['Customers','Drivers','Vehicles','PowerBI' , 'Finance Dashboard', 'Data Discrepancies'].indexOf(menuList[i].name)==-1){
                m.push(menuList[i])
            }
        }else{
            m.push(menuList[i])
        }
    }
    menuList = m
}
    


console.log(configStore?.currentSelectedEntity, "select");
let currentEntity = localStorage.getItem('ag_current_entity')
currentEntity = JSON.parse(currentEntity)
console.log(currentEntity, "air");
const clientMenuList = [
    // {
    //     name: 'Dashboard',
    //     href: '/',
    //     component: <Dashboard/>
    // },
    {
        name: 'Home',
        key: 'Home',
        href: '/',
        component: <ChartNewHome />,
        classname: "home",
    },
    {
        name: 'Cross-Border',
        key: '',
        classname: "crossborder",
        children: [
            {
                name: 'Enquiries',
                key: 'Enquiries',
                href: '/',
                component: <EnquiryHome />,
                classname: "enquiries"
            },
            {
                name: 'Spot',
                key: 'Spot Booking - LCL',
                href: '/',
                component: <PricingScreen2 />,
                classname: "pricingcalculator",
            },
            {
                name: 'Spot - WIP',
                key: 'Spot Booking WIP',
                href: '/',
                component: <Spotv3 />,
                isRoleBased: true,
                classname: "spotv3",
            },
            // {
            //     name: 'Create Booking',
            //     key: 'Create Booking',
            //     href: '/',
            //     component: <HomeMain />,
            //     classname: "crossborder_bookings",
            // },
            {
                name: 'Create Booking',
                key: 'Create Bookingv2',
                href: '/',
                component: <HomeMainv2 />,
                classname: "crossborder_bookings",
            },
            // {
            //     name: 'My Bookings',
            //     key: 'Bookings',
            //     href: '/',
            //     component: <ListBookingsMain />,
            //     classname: "crossborder_bookings",
            // },
            {
                name: 'My Bookings',
                key: 'Bookingsv2',
                href: '/',
                component: <ListBookingsMainv2 />,
                classname: "crossborder_bookings",
            },
            {
                name: 'Visibility',
                key: 'Visibility',
                href: '/',
                component: <CustomerMyactions />,
                classname: "visibility",
            },
            {
                name: 'My Actions',
                key: 'My Actions',
                href: '/',
                component: <TaskList />,
                classname: "myactions",
            },

        ],
    },
    {
        name: 'Domestic Transport',
        key: '',
        classname: "domestictransport",
        children: [
            {
                name: 'Contracts',
                key: 'Domestic Transport',
                href: '/',
                component: <DtContractMain />,
                classname: "domesticcontracts",
            },
            {
                name: 'Bookings',
                key: 'Domestic Transport Booking',
                href: '/',
                component: <DtBookingMain />,
                classname: "domestictransport_bookings",
            },
        ],
    },
    {
        name: 'Access Control',
        key: 'Devices',
        href: '/',
        component: <Devices />,
        classname: "devices",
    },
    {
        name: 'Track My Bookings',
        key: 'Track My Bookings',
        href: '/',
        component: <TrackMyBooking />,
        classname: "Track My Bookings",
        excludeMenu: true,
    }

]

export default menuList
export {
    clientMenuList
}